import { apiConfig } from "./apiConfig";
import { servieModal } from "./servicesListDisplayModal";
export function getFullAttributeApi(franchiseWebLocationId:any,successHandler:any){
    $.ajax({
        type: "GET",
        url: apiConfig.fullAttribute +'?franchiseWeblocationId='+franchiseWebLocationId+'&apikey=' + window.DEFINE_VALUE.JS_API_KEY,
        contentType: "application/json",
        dataType: 'json',
        async:false,
        success: function(data:any){
            var locationDoingBusinessAs = data.locationDoingBusinessAs;
            window.objOSGlobal.requestBodyValues.WebLocationCountry = data.country;
            window.objOSGlobal.requestBodyValues.LeadOrigin = "BrandWebsite";
            window.objOSGlobal.requestBodyValues.LeadSource = "BrandWebsite";
            window.objOSGlobal.requestBodyValues.WebLocationAccountCode = data.franchiseWebLocationMarketingId;
            var phoneNumber = data.mainPhoneNumber ? data.mainPhoneNumber.toString().match(/(\d{3})(\d{3})(\d{4})/) : null;
            if (phoneNumber){
                phoneNumber = "(" + phoneNumber[1] + ") " + phoneNumber[2] + "-" + phoneNumber[3];
            }
            $('.call-details-text .phnNumber').empty();
            $('.call-details-text').removeClass('d-none');
            $('.results-phone-num').text(phoneNumber);
            $('.call-details-text a').attr('href',"tel:"+phoneNumber);
            $('.schedulerModalLabel').text(locationDoingBusinessAs);
            $('.schedulerModalLabel').removeClass('d-none');
            $('.modal-header-two #schedulermodallabel').text(locationDoingBusinessAs);
            $('#hms-lead-modal-header .hms-dbaName').text(locationDoingBusinessAs);
            $('.modal-header-two #schedulermodallabel').removeClass('d-none');
            $('.phone-number').text(phoneNumber);
            window.objOSGlobal.paramsUI.brandPhoneNumber = phoneNumber;
            window.objOSGlobal.paramsUI.doingBusinessAs = locationDoingBusinessAs;
            window.objOSGlobal.requestBodyValues.licenseNumber = data.contractNumber;
            window.objOSGlobal.requestBodyValues.IsLeadOnly = data.onlineScheduling ? false : true;
            window.objOSGlobal.requestBodyValues.calendarLead = data.onlineScheduling ? false : true;
            window.objOSGlobal.requestBodyValues.stateLicenseNumbers =data.stateLicenseNumbers;
            var brandCode = data.brandCode;
			if(brandCode != null && typeof(brandCode) != 'undefined') {
				var brands = window.objOSGlobal.requestBodyValues.Country == 'CA' ? "/ca/en-ca/_assets/brands.json" : "/us/en-us/_assets/brands.json";
                $.ajax({
                    type: "GET",
                    dataType: "json",
                    url: brands,
                    async: false, 
                    success: function(result:any) {
                        if (result.length > 0) {
                            var item:any = $.grep(result, function (e:any) { return e.code === brandCode  });
                            
                            if(item.length) {
                                    var logo = item[0].image;
                                    var phonenum = item[0].phone;
                                    var logoImg = `<img class="leadLogo" src="${logo}" width="249px"/>`
                                    var dbaName = `<p class="body-text sub-heading primary-theme-clr schedulerModalLabel">${locationDoingBusinessAs}</p>`
                                    $('.brand-logo').html(logoImg);
                                    $('.brand-logo').append(dbaName);
                                    $('.result-stack-logo').html(logoImg);
                                    $('.phnNumber').text(phonenum);
                                    sessionStorage.setItem("logo",logo);
                                    $('#calendar-screen .sub-heading').html(item[0].schedule_subtitle);
                                    let currentText = $('#calendar-screen .sub-heading').text();
                                    let updatedSubtitle = currentText.replace("{phoneNumber}", phonenum !=null ? phonenum.replace(/['"]+/g, ''):'');
                                    $('#calendar-screen .sub-heading').text(updatedSubtitle);
                                    if(item[0].disableServiceSelection){
                                        servieModal.enable = item[0].disableServiceSelection;
                                        sessionStorage.setItem("ServiceModalEnable", item[0].disableServiceSelection);
                                    }
                            }
                        }
                    }
                  });
			}
        if(successHandler){
            successHandler();
        }
        },
        error: function(error:any){
        }
    });
}